import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { convertFromConstantToHuman, QueryFilter, QueryFilterOperator } from '@liquitics/transaction';
import { SelectItem } from 'primeng/api/selectitem';
import { ReportDashboardColumnChooserDialogComponent } from '../report-dashboard-column-chooser-dialog.component';
@Component({
    selector: 'app-report-dashboard-query-filter',
    templateUrl: './report-dashboard-query-filter.component.html',
    styleUrls: ['./report-dashboard-query-filter.component.scss']
})
export class ReportDashboardQueryFilterComponent implements OnInit {

    @Input()
    columnGroupLabels: string[];
    @Input()
    columnGroups: any[][];
    @Input()
    distinctValues: { [columnName: string]: string[] } = {};
    @Input()
    customerColumnAliases: { [key: string]: string };
    @Input()
    supportedOperators: string[];

    @Input()
    queryFilters: QueryFilter[];

    operators: SelectItem[] = [
        { label: '=', value: '=' },
        { label: '!=', value: '!=' },
        { label: '>', value: '>' },
        { label: '>=', value: '>=' },
        { label: '<', value: '<' },
        { label: '<=', value: '<=' },
        { label: 'In', value: 'IN' },
        { label: 'Not In', value: 'NOT_IN' },
        { label: 'Between', value: 'BETWEEN' },
        { label: 'Not Between', value: 'NOT_BETWEEN' },
        { label: 'Empty', value: 'EMPTY' },
        { label: 'Not Empty', value: 'NOT_EMPTY' },
        { label: 'Contains', value: 'CONTAINS' },
    ];


    public formGroup: FormGroup;

    @ViewChild('filterTable', { static: false }) filterTable: MatTable<QueryFilter>;

    filterDataSource: MatTableDataSource<QueryFilter>;
    filterSelection = new SelectionModel<QueryFilter>(false, []);
    selectedFilter: QueryFilter;
    selectedFilterColumn: string;
    selectedFilterOperator: QueryFilterOperator;
    selectedFilterValue: string;
    selectedFilterInValues: string[];

    selectedFilterBetweenValue1: string;
    selectedFilterBetweenValue2: string;

    constructor(public dialog: MatDialog, ) {

    }

    ngOnInit() {
        this.formGroup = new FormGroup({
            'filterColumn': new FormControl(this.selectedFilterColumn, [
            ]
            ),
            'filterOperator': new FormControl(this.selectedFilterOperator, [
            ]
            ),
            'filterValue': new FormControl(this.selectedFilterValue, [
            ]
            ),
            'filterInValues': new FormControl(this.selectedFilterInValues, [
            ]
            ),
            'filterBetweenValue1': new FormControl(this.selectedFilterBetweenValue1, [
            ]
            ),
            'filterBetweenValue2': new FormControl(this.selectedFilterBetweenValue2, [
            ]
            ),
        });
        if (this.queryFilters) {
            this.setQueryFilters(this.queryFilters);
        }
    }

    setQueryFilters(filters: QueryFilter[]) {
        this.queryFilters = filters;
        this.filterDataSource = new MatTableDataSource<QueryFilter>(filters || []);
    }

    getQueryFilters(): QueryFilter[] {
        return this.filterDataSource.data;
    }

    onFilterSelect(sf: QueryFilter) {
        this.filterSelection.toggle(sf);
        if (this.filterSelection.isSelected(sf)) {
            this.selectedFilter = sf;
            this.selectedFilterColumn = sf.attributeColumn;
            this.selectedFilterOperator = sf.operator;
            this.selectedFilterValue = sf.value;
            this.selectedFilterInValues = sf.value?.split(',');
            this.selectedFilterBetweenValue1 = sf.value?.split('|')[0];
            this.selectedFilterBetweenValue2 = sf.value?.split('|')[1];

            this.filterColumn.setValue(sf.attributeColumn);
            this.filterOperator.setValue(sf.operator);
            this.filterValue.setValue(sf.value);
            this.filterInValues.setValue(sf.value?.split(','));
            this.filterBetweenValue1.setValue(sf.value?.split('|')[0]);
            this.filterBetweenValue2.setValue(sf.value?.split('|')[1]);
        } else {
            this.selectedFilter = null;
            this.selectedFilterColumn = null;
            this.selectedFilterOperator = null;
            this.selectedFilterValue = null;
            this.selectedFilterInValues = null;
            this.selectedFilterBetweenValue1 = null;
            this.selectedFilterBetweenValue2 = null;
        }
    }

    getFilterValue() {
        let filterValue;
        if (this.filterOperator.value === 'BETWEEN' || this.filterOperator.value === 'NOT_BETWEEN') {
            filterValue = `${this.filterBetweenValue1.value}|${this.filterBetweenValue2.value}`;

        } else if ((this.filterOperator.value === 'IN' || this.filterOperator.value === 'NOT_IN') &&
            (this.distinctValues && this.filterColumn.value && this.distinctValues[this.filterColumn.value])) {
            filterValue = this.filterInValues.value?.join(',');
        } else {
            filterValue = this.filterValue.value;
        }
        return filterValue;
    }

    addFilter(event) {
        if (this.filterColumn && this.filterOperator &&
            (this.filterValue || (this.filterBetweenValue1 && this.filterBetweenValue2))) {

            const newFilter: QueryFilter = {
                attributeColumn: this.filterColumn.value,
                operator: this.filterOperator.value,
                value: this.getFilterValue(),
            };
            if (!this.filterDataSource.data.find((filter) => {
                return filter.attributeColumn === newFilter.attributeColumn &&
                    filter.operator === newFilter.operator &&
                    filter.value === newFilter.value;
            })) {
                this.filterDataSource.data = [...this.filterDataSource.data, newFilter];
                this.queryFilters = this.queryFilters || [];
                this.queryFilters.push(newFilter);
            }
        }
        this.filterTable.renderRows();
    }

    updateFilter(event) {
        // // First delete the selected filter
        // const filters = this.filterDataSource.data
        //     .filter((filter) => {
        //         return !(filter.attributeColumn === this.selectedFilter.attributeColumn
        //             && filter.operator === this.selectedFilter.operator
        //             && filter.value === this.selectedFilter.value);
        //     });
        // this.filterDataSource.data = filters;
        // // Then readd it with the updated values
        // this.addFilter(event);
        if (this.selectedFilter) {
            this.selectedFilter.attributeColumn = this.filterColumn.value;
            this.selectedFilter.operator = this.filterOperator.value;
            this.selectedFilter.value = this.getFilterValue();
            this.filterTable.renderRows();
        }
    }


    // deleteFilter(event) {
    //     const filters = this.filterDataSource.data
    //         .filter((filter) => {
    //             return !(filter.attributeColumn === this.selectedFilter.attributeColumn
    //                 && filter.operator === this.selectedFilter.operator
    //                 && filter.value === this.selectedFilter.value);
    //         });
    //     this.filterDataSource.data = filters;
    //     this.filterTable.renderRows();
    // }

    deleteRow(filterToDelete) {
        const filters = this.filterDataSource.data
            .filter((filter) => {
                return !(filter.attributeColumn === filterToDelete.attributeColumn
                    && filter.operator === filterToDelete.operator
                    && filter.value === filterToDelete.value);
            });
        this.filterDataSource.data = filters;
        if (this.queryFilters) {
            const index = this.queryFilters
                .findIndex((filter) => {
                    return (filter.attributeColumn === filterToDelete.attributeColumn
                        && filter.operator === filterToDelete.operator
                        && filter.value === filterToDelete.value);
                })
            if (index > -1) {
                this.queryFilters.splice(index, 1);
            }
        }
        this.filterTable.renderRows();
    }

    openColumnChooserDialog() {
        const dialogRef = this.dialog.open(ReportDashboardColumnChooserDialogComponent, {
            width: '500px',
            height: '60vh',
            data: {
                columns: this.columnGroups
                    .reduce((flattened, columnGroup) => {
                        flattened.push(...columnGroup);
                        return flattened;
                    }, [])
            }
        });

        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result) {
                    this.filterColumn.setValue(result.value);
                }
            }
        });
    }

    aliasedColumnName(column: string): string {
        const labelToUse = this.customerColumnAliases[column] || convertFromConstantToHuman(column);
        return labelToUse;
    }

    get filterColumn() { return this.formGroup.get('filterColumn'); }
    get filterOperator() { return this.formGroup.get('filterOperator'); }
    get filterValue() { return this.formGroup.get('filterValue'); }
    get filterInValues() { return this.formGroup.get('filterInValues'); }
    get filterBetweenValue1() { return this.formGroup.get('filterBetweenValue1'); }
    get filterBetweenValue2() { return this.formGroup.get('filterBetweenValue2'); }


    isFilterValueUnnecessary(operator: string): boolean {
        return operator === 'BETWEEN' || operator === 'NOT_BETWEEN' || operator === 'EMPTY' || operator === 'NOT_EMPTY'
    }

    onFilterOperatorChange(event) {
        if (this.isFilterValueUnnecessary(this.filterOperator.value)) {
            this.filterValue.setValue(undefined);
        }
    }



}